
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.29 1.5A5.206 5.206 0 016 8.26M5.36 3.84a4.53 4.53 0 013.1-2.23","stroke":"#F8F4EE","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.62 5.79c.56-.75 1.32-1.36 2.25-1.73 1.91-.76 4-.31 5.43.98","stroke":"#F8F4EE","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.84 12.5c-.13-.74-.2-1.5-.2-2.28 0-2.38.64-4.62 1.76-6.54","stroke":"#F8F4EE","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.07 14.07a6.799 6.799 0 00-4.79-1.95c-1.86 0-3.55.75-4.79 1.95M13.57 5.8a1.54 1.54 0 100-3.08 1.54 1.54 0 000 3.08z","stroke":"#F8F4EE","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    